import { useState, useEffect } from 'react';
import { getApiBaseURL } from '../services/api';

/**
 * Хук для поиска одежды по URL страницы
 */
export const useClothFinder = (apiKey, apiUrl) => {
  const [selectedCloth, setSelectedCloth] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    const findClothByURL = async () => {
      try {
        const urlParams = new URLSearchParams(window.location.search);
        let websiteURL = urlParams.get('url');
        
        if (!websiteURL) {
          if (document.referrer && document.referrer !== window.location.href) {
            websiteURL = document.referrer;
          } else {
            try {
              if (window.parent && window.parent !== window) {
                websiteURL = window.parent.location.href;
              } else {
                websiteURL = window.location.href;
              }
            } catch (e) {
              websiteURL = window.location.href;
            }
          }
        }
        
        let searchURL = websiteURL;
        try {
          const normalizedURL = new URL(websiteURL);
          normalizedURL.search = '';
          normalizedURL.hash = '';
          searchURL = normalizedURL.toString();
        } catch (e) {
          console.warn('Could not parse URL:', websiteURL);
        }

        const apiBaseURL = getApiBaseURL(apiUrl);
        const headers = {};
        if (apiKey) {
          headers['X-API-Key'] = apiKey;
        }
        
        const response = await fetch(
          `${apiBaseURL}/api/v1/widget/clothes/find?website_url=${encodeURIComponent(searchURL)}`,
          { headers }
        );
        
        if (response.ok) {
          const cloth = await response.json();
          setSelectedCloth({
            _id: cloth.id,
            name: cloth.name,
            description: cloth.description,
            category: cloth.category,
            prompt: cloth.prompt,
            front_image_url: cloth.front_image_url,
            back_image_url: cloth.back_image_url,
            website_url: cloth.website_url
          });
        } else if (response.status === 404) {
          console.log('Clothes not found for URL:', searchURL);
          setNotFound(true);
        } else {
          console.error('Error finding clothes:', response.status);
        }
      } catch (error) {
        console.error('Error finding clothes by URL:', error);
      } finally {
        setLoading(false);
      }
    };

    findClothByURL();
  }, [apiKey, apiUrl]);

  return { selectedCloth, loading, notFound, setSelectedCloth };
};

